import React from 'react';
import { ChevronDown } from 'lucide-react';
import { Collapsible, CollapsibleContent, CollapsibleTrigger } from '../ui/collapsible';

// Collapsible info card used on the learner programme page.
export default function InfoPanel({ testId, title, icon: Icon, open, onToggle, aside, children }) {
  return (
    <div className={`rounded-2xl border bg-zinc-900 mb-4 transition-colors ${open ? 'border-zinc-700' : 'border-zinc-800 hover:border-zinc-700'}`} data-testid={testId}>
      <Collapsible open={!!open} onOpenChange={onToggle}>
        <CollapsibleTrigger asChild>
          <button type="button" className="w-full flex items-center gap-3 px-5 py-4 text-left" data-testid={`${testId}-toggle`}>
            {Icon && <span className="h-9 w-9 rounded-lg bg-teal-500/10 text-teal-400 flex items-center justify-center shrink-0"><Icon className="h-4 w-4" /></span>}
            <span className="flex-1 text-white font-semibold">{title}</span>
            {aside}
            <ChevronDown className={`h-5 w-5 text-zinc-500 transition-transform duration-200 ${open ? 'rotate-180' : ''}`} />
          </button>
        </CollapsibleTrigger>
        <CollapsibleContent>
          <div className="px-5 pb-5 pt-1 border-t border-zinc-800/80">{children}</div>
        </CollapsibleContent>
      </Collapsible>
    </div>
  );
}
